import React, { useEffect } from 'react';

const ConfirmPopup = ({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', onConfirm, onCancel, danger = false }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div className="sp-confirm-overlay" onClick={onCancel}>
      <div className="sp-confirm-popup" onClick={e => e.stopPropagation()}>
        <div className="sp-confirm-icon">
          <i className={`fas fa-${danger ? 'exclamation-triangle' : 'question-circle'}`}></i>
        </div>
        <div className="sp-confirm-body">
          <h4 className="sp-confirm-title">{title}</h4>
          {message && <p className="sp-confirm-message">{message}</p>}
        </div>
        <div className="sp-confirm-actions">
          <button className="sp-confirm-btn sp-confirm-cancel" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button className={`sp-confirm-btn${danger ? ' sp-confirm-danger' : ' sp-confirm-ok'}`} onClick={onConfirm} autoFocus>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
